import Gooey, { mount, Component, Dyn, dynSet } from '@srhazi/gooey';

export const NumberInput: Component<{
    value: Dyn<number>;
    id?: Dyn<string>;
    type?: Dyn<'number' | 'range'>;
    min?: Dyn<string | number>;
    max?: Dyn<string | number>;
    step?: Dyn<string | number>;
}> = ({ id, value, type = 'number', min, max, step }) => {
    return (
        <input
            id={id}
            on:input={(e, el) => {
                dynSet(value, el.valueAsNumber);
            }}
            value={value}
            type={type}
            min={min}
            max={max}
            step={step}
        />
    );
};
